import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MaskField } from '../../../elements';
import getErrorMsg from '../../../helpers/errorMessages';
import { VRPAT } from '~/config/constants';

const Description = styled.p`
  font-size: 0.9375rem;
  margin-bottom: 8px;
`;

const Content = styled.div`
  display: block;
  text-align: center;

  ${({ color }) => css`
    input {
      color: ${color} !important;
      border-bottom-color: ${color} !important;
    }
    label {
      color: ${color} !important;
      font-size: 15px !important;
    }
    .MuiInput-underline::before,
    .MuiInput-underline::after {
      border-color: ${color} !important;
    }
    .MuiIconButton-root {
      display: none;
    }
    .MuiInputBase-input {
      caret-color: ${color} !important;
      -webkit-text-fill-color: ${color} !important;
    }
  `}
`;

export default function CurrentCardNumber({ errors, formControl, activeCard }) {
  const issuer = useSelector(state => state?.issuer?.name);
  const color = issuer === VRPAT ? 'white' : 'black';

  function validateCard(cardNumber) {
    const currentNumber = cardNumber
      .split(' ')
      .join('')
      .slice(-4);

    if (currentNumber === activeCard?.numeroCartao.slice(-4)) {
      return true;
    }
    return false;
  }

  return (
    <Content color={color}>
      <Description>Número do cartão</Description>

      <MaskField
        ariaLabel="número do cartão"
        fullWidth
        name="cardNumberChangingPassword"
        mask="9999  9999  9999  9999"
        type="tel"
        rules={{
          required: true,
          minLength: 22, // 22 e não 16 pois precisa contar os espaços da mask
          validate: val => validateCard(val),
        }}
        formControl={formControl}
        error={!!errors.cardNumberChangingPassword}
        caption={getErrorMsg(errors, 'cardNumberChangingPassword')}
        style={{
          marginBottom: '20px',
        }}
      />
    </Content>
  );
}

CurrentCardNumber.propTypes = {
  errors: PropTypes.object,
  formControl: PropTypes.object.isRequired,
};
